import './ThemeSwitch.scss';

import ThemeSwitch from './ThemeSwitch';

export default ThemeSwitch;
